<template>
  <div class="h-full w-full relative">
    <div id="map-full-screen" class="h-full w-full"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VMapCanvas",
  inject: ['maps'],
  props: {
    mapId: String,
    center: {
      type: Object,
      default: () => ({
        lat: 0,
        lng: 0
      })
    }
  },
  data() {
    return {
      context: {
        map: null
      }
    }
  },
  watch: {
    center(v) {
      this.context.map.setZoom(14)
      this.context.map.setCenter(v);
    }
  },
  computed: {
    getContext(){
      return this.context;
    }
  },
  provide(){
    return this.getContext;
  },
  mounted() {
    this.context.map = new this.maps.Map(document.getElementById("map-full-screen"), {
      center: this.center,
      zoom: 14,
      mapId: this.mapId,
    });

    this.context.map.addListener('center_changed', () => {
      this.$emit('center_changed', this.context.map.getCenter())
      
    })
  }
}
</script>

<style lang="scss" scoped></style>